import { Component, EventEmitter, Output } from '@angular/core';

import { STEPS } from '~/models/document-finder.models';
import { DocumentFinderService } from '~/services/document-finder.service';

@Component({
    selector: 'df-stepper',
    template: `
    <div class="stepper" role="list">
      <button *ngFor="let s of steps; let i = index" type="button" role="listitem" class="st"
        [class.on]="i + 1 === df.step" [class.done]="i + 1 < df.step"
        [disabled]="isDisabled(i + 1)"
        [attr.aria-current]="i + 1 === df.step ? 'step' : null"
        (click)="stepSelected.emit(i + 1)">
        <span class="n">{{ i + 1 < df.step ? '✓' : i + 1 }}</span>{{ s }}
      </button>
    </div>`,
    styleUrls: ['./df-stepper.component.scss'],
    standalone: false
})
export class DfStepperComponent {
    public readonly steps = STEPS;
    @Output() stepSelected = new EventEmitter<number>();

    constructor(public df: DocumentFinderService) {}

    /** Steps past the furthest reached are locked. Any reached step, including Retrieve, can be revisited. */
    public isDisabled(n: number): boolean {
        return n > this.df.maxStep;
    }
}
